module.exports = __webpack_public_path__ + "img/t5-c9.b8a2b8de.png";